import { Box, Button, Group, Text } from "@mantine/core";
import { OrgPermissions } from "beitary-shared";
import { BBox } from "components";
import { BCan } from "permissions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SMSTemplatesTable } from "./components";

export const SMSTemplates = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <BBox
      header={
        <Group position="apart">
          <Text size="sm" weight={500}>
            {t("SMS_TEMPLATES")}
          </Text>
          <BCan I="do" a={OrgPermissions.CLIENT_COMMUNICATION}>
            <Button onClick={() => navigate("new")}>{t("ADD_NEW")}</Button>
          </BCan>
        </Group>
      }
    >
      <Box p="xl">
        <SMSTemplatesTable />
      </Box>
    </BBox>
  );
};
